function validSelection(selection) {
  try {
    return Number.isInteger(selection?.from)
      && Number.isInteger(selection?.to)
      && selection.from < selection.to
      && typeof selection.text === "string";
  } catch {
    return false;
  }
}

export function createAiRewriteController({
  modal,
  preview,
  suggestion,
  getInstruction = () => "",
  rewriteSelection,
  replaceSelection,
  onToast = () => {},
  onApplied = () => {},
  onOpen = () => {}
} = {}) {
  if (!modal || !preview || !suggestion) throw new TypeError("AI rewrite elements are required");
  if (typeof rewriteSelection !== "function" || typeof replaceSelection !== "function") {
    throw new TypeError("AI rewrite services are required");
  }

  let epoch = 0;
  let currentSelection = null;
  let currentText = "";
  let currentSuggestion = "";

  function isCurrent(requestEpoch, selection) {
    return epoch === requestEpoch && currentSelection === selection && modal.open === true;
  }

  async function refresh() {
    if (!validSelection(currentSelection) || !currentText.trim() || modal.open !== true) return;
    const selection = currentSelection;
    const selectedText = currentText;
    const requestEpoch = ++epoch;
    currentSuggestion = "";
    suggestion.textContent = "正在生成建议...";
    let result;
    try {
      result = await rewriteSelection({ selectedText, instruction: getInstruction() });
    } catch (error) {
      if (!isCurrent(requestEpoch, selection)) return;
      const message = typeof error?.message === "string" && error.message ? error.message : "未知错误";
      suggestion.textContent = `生成失败：${message}`;
      return;
    }
    if (!isCurrent(requestEpoch, selection)) return;
    currentSuggestion = typeof result?.suggestion === "string" ? result.suggestion : "";
    suggestion.textContent = currentSuggestion;
  }

  function open(selection) {
    if (!validSelection(selection) || !selection.text.trim()) return Promise.resolve();
    epoch += 1;
    currentSelection = selection;
    currentText = selection.text;
    currentSuggestion = "";
    try { onOpen(selection); } catch {}
    preview.textContent = currentText;
    if (!modal.open) modal.showModal();
    return refresh();
  }

  function apply() {
    const selection = currentSelection;
    const selectedText = currentText;
    const value = currentSuggestion.trim();
    if (!validSelection(selection) || !selectedText.trim() || !value) return false;
    epoch += 1;
    let replaced = false;
    try { replaced = replaceSelection(value, selection) === true; } catch {}
    if (!replaced) {
      try { onToast("原选区内容已变化，请重新选择后再试"); } catch {}
      return false;
    }
    currentSelection = null;
    currentText = "";
    currentSuggestion = "";
    if (modal.open) modal.close();
    try { onApplied(); } catch {}
    try { onToast("已应用 AI 修改到原文"); } catch {}
    return true;
  }

  function invalidate() {
    epoch += 1;
  }

  return { open, refresh, apply, invalidate };
}
